import Benefits from "../../layouts/landingPage/benefits/benefits";
import FeaturedAnalysisCards from "../../layouts/landingPage/featuredAnalysis/featuredAnalysis";
import Features from "../../layouts/landingPage/features/features";
import Hero from "../../layouts/landingPage/hero/hero";
import Navbar from "../../layouts/landingPage/navbar/navbar";
import "./landingPage.css";

export default function LandingPage() {
    return (
        <div className="landing-page">
            <Navbar />
            <Hero />
            <Benefits />
            <Features />
            <FeaturedAnalysisCards />
        </div>
    );
}